import {useCallback} from 'react';

export const useOrderUpdate = ({ orderId, getOrder, setOrder }) => {
    const updateOrder = useCallback(() => {
        if (orderId) {
            getOrder(orderId)
                .then((res) => {
                    setOrder(res);
                })
                .catch(console.error);
        }
    }, [orderId, getOrder, setOrder]);

    return updateOrder;
};